// extracted by mini-css-extract-plugin
export default {"wrap":"NotifyBox_wrap__EvA0A","main":"NotifyBox_main__XfvOi"};